import type { AxiosRequestConfig } from 'axios';
import {
  createLotusAxiosConfig as createWebKitLotusAxiosConfig,
  createLotusRequestConfig as createWebKitLotusRequestConfig,
  installLotusErrorInterceptor,
  getAccessToken as getWebKitAccessToken,
  type LotusRequestOptionsT,
} from '@lotushealth/web_kit/api';

import { auth } from '@/shared/libs/firebase';
import { ENV } from '@/shared/config';

installLotusErrorInterceptor();

/**
 * Get the current user's Firebase ID token for API authorization.
 * Returns null if no user is authenticated.
 */
export async function getAccessToken(): Promise<string | null> {
  return getWebKitAccessToken(auth);
}

/**
 * Create an Axios request config with Lotus Health API authorization.
 * Throws if no user is authenticated.
 */
export async function createLotusAxiosConfig(): Promise<AxiosRequestConfig> {
  return createWebKitLotusAxiosConfig(auth, ENV);
}

export type LotusRequestOptions = LotusRequestOptionsT;

/**
 * Axios config for SDK calls (auth + baseURL + cancellation).
 */
export async function createLotusRequestConfig(
  options: LotusRequestOptions = {}
): Promise<AxiosRequestConfig> {
  return createWebKitLotusRequestConfig(auth, ENV, options);
}
